import * as bitcoin from 'bitcoinjs-lib';
import decimal from 'decimal.js';
import { words } from './globalState';
import {
  toFloat,
  decimalAdjust,
  devLog,
  syncHttpRequest,
  syncHttpRequestText,
  syncHttpRequest2,
  sleep,
} from './utils';

// BUILD MONAPARTY TRANSACTIONS
// この関数は、 walletCore に移す予定。
async function buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources) {
  let requestToMonapartyServer = {};
  let bodyObject = {};
  let result = {};
  let response = {};
  let outValueExcludeChange;
  let change;
  let transactionFee;
  let transactionUnsigned;
  let transactionSigned;
  let serverIndex = 0;

  requestToMonapartyServer.method = 'POST';

  devLog('actionItemsMultiSources', JSON.stringify(actionItemsMultiSources));

  SOURCE: for (const source of Object.keys(actionItemsMultiSources)) {
    const keyPair = keyPairs[source]?.keyPair;
    // const publicKey = keyPair?.publicKey;
    // const publicKeyHex = publicKey?.toString('hex');

    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[source]) {
      // actionItem単位でトランザクションを作成し、ブロードキャストする。

      if (actionItem.status === 'unprocessed') {
        if (actionItem.action === 'send') {
          // パラメータ作成

          const destinations = [];
          const assets = [];
          const quantitys = [];

          for (const destination of Object.keys(actionItem.recipients)) {
            for (const asset of Object.keys(actionItem.recipients[destination])) {
              destinations.push(destination);
              assets.push(asset);
              quantitys.push(actionItem.recipients[destination][asset].quantity);
            }
          }

          if (destinations.length < 1 || assets.length < 1 || quantitys.some( quantity => quantity <= 0)) {
            continue ACTION_ITEM;
            // break SOURCE;
          }

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_send",
              "params": {
                "source": source,
                "destination": destinations.length >= 2 ? destinations : destinations[0],
                "asset": assets.length >= 2 ? assets : assets[0],
                "quantity": quantitys.length >= 2 ? quantitys : quantitys[0],
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);
        }
        else if (actionItem.action === 'issue') {
          // パラメータ作成

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_issuance",
              "params": {
                "source": source,
                // "encoding": "multisig",
                // "pubkey": publicKeyHex,
                "asset": actionItem.assetCommon,
                "quantity": actionItem.quantity,
                "description": actionItem.description,
                "divisible": actionItem.divisible,
                "listed": actionItem.listed,
                "vendable": actionItem.vendable,
                "reassignable": actionItem.reassignable,
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);
        }
        else if (actionItem.action === 'editMonacard' || actionItem.action === 'additionalIssuance' || actionItem.action === 'editAdvancedToken') {
          // パラメータ作成

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_issuance",
              "params": {
                "source": source,
                "asset": actionItem.asset,
                "quantity": actionItem.quantity,
                "description": actionItem.description,
                "divisible": actionItem.divisible,
                "listed": actionItem.listed,
                "vendable": actionItem.vendable,
                "reassignable": actionItem.reassignable,
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);
        }
        else if (actionItem.action === 'lockIssuance') {
          // パラメータ作成

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_issuance",
              "params": {
                "source": source,
                "asset": actionItem.asset,
                "quantity": actionItem.quantity,
                "description": actionItem.description,
                "divisible": actionItem.divisible,
                "listed": actionItem.listed,
                "vendable": actionItem.vendable,
                "reassignable": actionItem.reassignable,
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);
        }
        else if (actionItem.action === 'transferOwnership') {
          // パラメータ作成

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_issuance",
              "params": {
                "source": source,
                "asset": actionItem.asset,
                "transfer_destination": actionItem.addressNewOwner,
                "quantity": actionItem.quantity,
                "description": actionItem.description,
                "divisible": actionItem.divisible,
                "listed": actionItem.listed,
                "vendable": actionItem.vendable,
                "reassignable": actionItem.reassignable,
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);
        }
        // else if (actionItem.action === 'additionalIssuance') {
        //   // パラメータ作成

        //   bodyObject = {
        //     "jsonrpc":"2.0",
        //     "id":0,
        //     "method":"proxy_to_counterpartyd",
        //     "params": {
        //       "method":"create_issuance",
        //       "params": {
        //         "source": source,
        //         "asset": actionItem.assetCommon,
        //         "quantity": actionItem.quantity,
        //         // "description": actionItem.description,
        //         // "lock": actionItem.lock,
        //         "divisible": actionItem.divisible,
        //         "listed": actionItem.listed,
        //         "vendable": actionItem.vendable,
        //         "reassignable": actionItem.reassignable,
        //         "extended_tx_info": true,
        //       }
        //     }
        //   };

        //   requestToMonapartyServer.body = JSON.stringify(bodyObject);
        // }
        else { // unknown action
        }

        // トランザクション作成

        let buildTransactionRetryCount = 0;

        while (response.status !== 'fulfilled' || response.body.error !== undefined) {
          requestToMonapartyServer.url = `https://${state.config.clientParameters.monapaServer.domainAndPath[serverIndex]}`;
          console.log('request create_send', JSON.stringify(requestToMonapartyServer));

          response = await syncHttpRequest(requestToMonapartyServer);
          console.log('response', JSON.stringify(response));

          if (response.status === 'rejected' || response.body.error !== undefined) {
            devLog('build transaction in counterpartyd; rejected');
            buildTransactionRetryCount++;

            if (serverIndex >= state.config.clientParameters.monapaServer.domainAndPath.length - 1) {
              serverIndex = 0;
            }
            else {
              serverIndex++;
            }

            await sleep(state.config.clientParameters.retry.buildTransaction.retryWaitingTime);
            // await setTimeout(state.config.clientParameters.retry.buildTransaction.retryWaitingTime);
            // keepSqsMessage = true;
            // continue;
          }
          else {
            transactionUnsigned = response.body.result.tx_hex;
            outValueExcludeChange = response.body.result.btc_out;
            change = response.body.result.btc_change;
            transactionFee = response.body.result.btc_fee;
            devLog('transactionUnsigned', transactionUnsigned);
          }

          if (buildTransactionRetryCount > state.config.clientParameters.retry.buildTransaction.retryMax) {
            // -- retry over エラー終了
            const error = response.status === 'rejected' ? response.error : response.body.error;

            devLog(`build transaction retry over.; ${error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; ${JSON.stringify(error)}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToBuildTransaction';
            actionItem.error = error;
            continue ACTION_ITEM;
            // break SOURCE;
          }
        }

        // トランザクション署名

        if (keyPair !== undefined) {
          result = {};

          result = signTransaction(state.networkMona, transactionUnsigned, keyPair);
          devLog('sign transaction; result', JSON.stringify(result));

          if (result.status === 'fulfilled') {
            devLog('succeeded to sign transaction.');

            transactionSigned = result.body;
            actionItem.transactionSigned = transactionSigned;
            actionItem.outValueExcludeChange = outValueExcludeChange;
            actionItem.change = change;
            actionItem.transactionFee = transactionFee;
            actionItem.status = 'succeeded';
            actionItem.statusDetail = 'signed';
          }
          else {
            devLog(`failed to sign transaction.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]}; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToSignWithKey';
            actionItem.error = result.error;
            continue ACTION_ITEM;
            // break SOURCE;
          }
        }
        else if (window.mpurse) { // Mpurse
          result = {};

          result = await window.mpurse.signRawTransaction(transactionUnsigned)
          .then( async (result) => {
            devLog('succeeded to sign transaction.');
            devLog(result);

            return {
              status: 'fulfilled',
              body: result,
            };
          })
          .catch( (error) => {
            // devLog('failed to sign transaction.');
            // devLog(error);

            // notification
            // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSignTransaction[state.language] });

            return {
              status: 'rejected',
              body: error
            };
          });

          if (result.status === 'fulfilled') {
            devLog('succeeded to sign transaction.');

            transactionSigned = result.body;
            actionItem.transactionSigned = transactionSigned;
            actionItem.outValueExcludeChange = outValueExcludeChange;
            actionItem.transactionFee = transactionFee;
            actionItem.status = 'succeeded';
            actionItem.statusDetail = 'signed';
          }
          else {
            devLog(`failed to sign transaction with Mpurse.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]}; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToSignWithMpurse';
            actionItem.error = result.error;
            continue ACTION_ITEM;
            // break SOURCE;
          }
        }
        else {
          devLog('failed to sign transaction.; no keyPair and no Mpurse.');
          dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]} ${words.pleaseLogin[state.language]}` });
        }

        // break SOURCE;
      }
    }
  }

  return actionItemsMultiSources;
}

// BROADCAST MONA TRANSACTIONS
async function broadcastMonaTransactions(state, dispatch, actionItemsMultiSources) {

  // ブロードキャスト

  for (const addressFrom of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
      if (actionItem.statusDetail === 'signed') {
        const result = await broadcastTransaction({ clientParameters: state.config.clientParameters, signedTxHex: actionItem.transactionSigned });

        if (result.status === 'fulfilled') {
          actionItem.txid = result.body;
          actionItem.status = 'succeeded';
          actionItem.statusDetail = 'broadcasted';

          // notification
          dispatch({ type: 'setNotification', key: 'notification', value: words.sentSuccessfully[state.language] });
        }
        else {
          devLog('failed to broadcast transaction.');
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '8' });

          actionItem.status = 'failed';
          actionItem.statusDetail = 'failedToBroadcastTransaction';
          continue ACTION_ITEM;
        }
      }
    }
  }

  return actionItemsMultiSources;
}

// GET UTXO
async function getUtxo({ clientParameters, address }) {
  let serverIndex = 0;
  const servers = clientParameters.utxoIndexServer.utxo;

  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    const server = servers[serverIndex];

    if (server.status !== 'enabled') {
      serverIndex++;
      continue SERVER;
    }

    if (server.type === 'blockbook') {
      request.url = `https://${server.domainAndPath}${address}`;
      // request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.utxoPath}${address}`;
    }
    else if (server.type === 'electrs') {
      request.url = `https://${server.domainAndPath}${address}${server.path2}`;
    }

    devLog('get UTXO; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get UTXO; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      let utxos;
      if (server.type === 'blockbook') {
        utxos = response.body;
      }
      else if (server.type === 'electrs') {
        utxos = response.body.map( (utxo) => {
          return {
            txid: utxo.txid,
            vout: utxo.vout,
            satoshis: utxo.value,
          };
        });
      }
      devLog('utxos', JSON.stringify(utxos));

      return {
        status: 'fulfilled',
        body: utxos,
      };
    }
    else {
      devLog('get UTXO; rejected');

      if (serverIndex >= servers.length - 1) {
        return {
          status: 'rejected',
          error: response.body + request.url,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// SELECT UTXO MONA
// モナコインUTXO選定
// -- utxosは昇順ソート
function selectUtxoMona(utxos, amount) {
  devLog('selectUtxoMona', JSON.stringify(utxos), amount);
  const minimumGrater= minimumGraterUtxo(utxos, amount);
  devLog('minimumGrater', JSON.stringify(minimumGrater));

  if (minimumGrater !== null) {
    return [minimumGrater];
  }
  else {
    if (utxos.length <= 1) {
      return null;
    }

    const maximum = utxos.pop();
    devLog('maximum', JSON.stringify(maximum));
    const supplement = selectUtxoMona(utxos, amount - maximum.amount);

    if (supplement !== null) {
      supplement.unshift(maximum);
      return supplement;
    }
    else {
      return null;
    }
  }
}

function minimumGraterUtxo(utxos, bound) {
  devLog('minimumGraterUtxo', JSON.stringify(utxos), bound);
  let result = null;

  for(const utxo of utxos) {
   if (utxo.amount >= bound) {
     result = utxo;
     break;
   } 
  }

  return result;
}

// SELECT UTXO WATANABE
// モナコインUTXO選定
// -- utxosは昇順ソート
function selectUtxoWatanabe(utxos, amount) {
  devLog('selectUtxoWatanabe', JSON.stringify(utxos), amount);
  const minimumGrater= minimumGraterUtxoWatanabe(utxos, amount);
  devLog('minimumGrater', JSON.stringify(minimumGrater));

  if (minimumGrater !== null) {
    return [minimumGrater];
  }
  else {
    if (utxos.length <= 1) {
      return null;
    }

    const maximum = utxos.pop();
    devLog('maximum', JSON.stringify(maximum));
    const supplement = selectUtxoWatanabe(utxos, amount - maximum.satoshis);

    if (supplement !== null) {
      supplement.unshift(maximum);
      return supplement;
    }
    else {
      return null;
    }
  }
}

function minimumGraterUtxoWatanabe(utxos, bound) {
  devLog('minimumGraterUtxo', JSON.stringify(utxos), bound);
  let result = null;

  for(const utxo of utxos) {
   if (utxo.satoshis >= bound) {
     result = utxo;
     break;
   } 
  }

  return result;
}

// GET TRANSACTION
// swap でのみしか使用していないので、未メンテナンス。
async function getTransaction(state, txid) {
  let transaction;
  let serverIndex = 0;

  // transaction取得
  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.transactionDetailPath}${txid}`;
    devLog('get transaction; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get transaction; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      transaction = response.body;
      devLog('transaction', JSON.stringify(transaction));

      return {
        status: 'fulfilled',
        body: transaction,
      };
    }
    else {
      devLog('get transaction; rejected');

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// GET RAW TRANSACTION
async function getRawTransaction(state, utxosSelected) {
  let serverIndex = 0;

  let request = {};
  request.method = 'POST';

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    // request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';

    for (const utxo of utxosSelected) {
      request.body = `{"jsonrpc":"2.0","id":0,"method":"proxy_to_counterpartyd","params":{"method":"getrawtransaction","params":{"tx_hash":"${utxo.txid}"}}}`;
      devLog('get UTX raw transaction; request', JSON.stringify(request));

      const response = await syncHttpRequest(request);
      devLog('get UTX raw transaction; response', JSON.stringify(response));

      if ( response.status === 'rejected' || response.body.error !== undefined ) {
        devLog('get UTXO; rejected');
        const error = response.status === 'rejected' ? response.error : response.body.error;

        if (serverIndex >= state.config.clientParameters.monapaServer.domainAndPath.length - 1) {
          // -- 失敗 エラー返却
          return {
            status: 'rejected',
            error: error
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }

      utxo.rawTransaction = response.body.result;
    }

    break SERVER;
  }

  return {
    status: 'fulfilled',
    body: utxosSelected,
  };
}

// GET ADDRESS INFO
async function getAddressInfo({ clientParameters, address }) {
  let addressInfo;
  let serverIndex = 0;
  const servers = clientParameters.utxoIndexServer.address;

  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    const server = servers[serverIndex];

    if (server.status !== 'enabled') {
      serverIndex++;
      continue SERVER;
    }

    if (server.type === 'blockbook') {
      request.url = `https://${server.domainAndPath}${address}${server.queryParameter}`;
      // request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.addressPath}${address}?details=basic`;
    }
    else if (server.type === 'electrs') {
      request.url = `https://${server.domainAndPath}${address}`;
    }

    devLog('get address info; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get address info; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      if (server.type === 'blockbook') {
        addressInfo = response.body;
      }
      else if (server.type === 'electrs') {
        const funded_txo_sum = response.body.chain_stats.funded_txo_sum;
        const spent_txo_sum = response.body.chain_stats.spent_txo_sum;
        const balance = funded_txo_sum - spent_txo_sum;
        addressInfo = {
          balance,
        };
      }

      devLog('address info', JSON.stringify(addressInfo));

      return {
        status: 'fulfilled',
        body: addressInfo,
      };
    }
    else {
      devLog('get address info; rejected', response.error);

      if (serverIndex >= servers.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// GET FEE RATE
async function getFeeRate({ clientParameters }) {
  let feeRate;
  let serverIndex = 0;
  const servers = clientParameters.utxoIndexServer.fee;

  // fee rate取得
  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };
  // delete request.body;

  SERVER: while (true) {
    const server = servers[serverIndex];

    if (server.status !== 'enabled') {
      serverIndex++;
      continue SERVER;
    }

    if (server.type === 'blockbook') {
      request.url = `https://${server.domainAndPath}${server.feeBlocks}`;
      // request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.feePath}${state.config.clientParameters.blockbook.feeBlocks}`;
    }
    else if (server.type === 'electrs') {
      request.url = `https://${server.domainAndPath}`;
    }

    devLog('get fee rate; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get fee rate; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      if (server.type === 'blockbook') {
        if (response.body.result === '0') {
          feeRate = 0.002;
        }
        else {
          feeRate = toFloat(response.body.result);
        }
      }
      else if (server.type === 'electrs') {
        const feeRatesByTargetBlocks = response.body;
        const feeRateWatanabePerVirtualByte = feeRatesByTargetBlocks[server.feeBlocks.toString()];
        const feeRateWatanabePerVirtualByteDecimal = new decimal(feeRateWatanabePerVirtualByte); // MONA/KB = 10^8watanabe/10^3byte = 10^5watanabe/byte
        const feeRateMonaPerKB = decimalAdjust( 'floor',  feeRateWatanabePerVirtualByteDecimal.div(100000).toNumber(), 0 ); 
        feeRate = feeRateMonaPerKB;

        if (feeRate < 0.002) {
          feeRate = 0.002;
        }
      }

      devLog('feeRate', feeRate);

      return {
        status: 'fulfilled',
        body: feeRate,
      };
    }
    else {
      devLog('get fee rate; rejected');

      if (serverIndex >= servers.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// CALCULATE CHANGE WATANABE
function calculateChangeWatanabe(utxosSelected, baseAmountWatanabe, feeRate, virtualSize, transactionFeeUpperBound) {
  // 概算バイト数計算

  const feeRateDecimal = new decimal(feeRate); // MONA/KB = 10^8watanabe/10^3byte = 10^5watanabe/byte
  const transactionFee = decimalAdjust( 'floor',  feeRateDecimal.times(100000).times(virtualSize).toNumber(), 0 ); 
  const amountToPay = baseAmountWatanabe + transactionFee;
  const change = utxosSelected.reduce( (acc, cur) => acc + cur.satoshis, 0 ) - amountToPay;
  devLog(`transactionFee ${transactionFee}, amountToPay ${amountToPay}, change ${change}`);

  // transactionFee歯止め

  if (transactionFee > transactionFeeUpperBound) {
    devLog('transactionFee is too high.');
    return {
      status: 'rejected',
      error: 'transactionFeeIsTooHigh',
    };
  }

  return {
    status: 'fulfilled',
    body: {
      change,
      transactionFee,
    },
  };
}

// BUILD UNSIGNED TRANSACTION SEND MONA
function buildUnsignedTransactionSendMona(network, inputs, outputs) {
  try {
    console.log('A');

    const txb = new bitcoin.TransactionBuilder(network);

    console.log('B');

    for (const input of inputs) {
      const inputTransaction = bitcoin.Transaction.fromHex(input.rawTransaction);
      console.log(JSON.stringify(inputTransaction.outs[input.vout].script));
      input.scriptPubkey = inputTransaction.outs[input.vout].script;
      console.log(input.scriptPubkey);
      txb.addInput(input.txid, input.vout, null, input.scriptPubkey);
    }

    console.log('C');

    for (const output of outputs) {
      txb.addOutput(output.address, output.amount);
    }

    console.log('D');

    const unsignedTx = txb.buildIncomplete();

    console.log('E');
    console.log(inputs[0].scriptPubkey);

    for (let i = 0; i <= unsignedTx.ins.length - 1; i++) {
      console.log(i);
      unsignedTx.ins[i].script = inputs[i].scriptPubkey;
    }

    console.log('F');

    const unsignedTxHex = unsignedTx.toHex();

    return {
      status: 'fulfilled',
      body: unsignedTxHex,
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
    };
  }
}

// SIGN TRANSACTION
function signTransaction(network, txHex, keyPair, wif) {
  devLog('keyPair.network === network', keyPair.network === network);

  try {
    if (keyPair === undefined || keyPair === null) {
      keyPair = bitcoin.ECPair.fromWIF(wif, network);
    }

    const tx = bitcoin.Transaction.fromHex(txHex);   // The unsigned second part of the 2 part P2SH transactions
    const txb = bitcoin.TransactionBuilder.fromTransaction(tx, network);

    for (let i = 0; i < tx.ins.length; i++) {
      txb.sign(i, keyPair);
    }

    const signedTxHex = txb.build().toHex();

    console.log('inner result', signedTxHex);

    return {
      status: 'fulfilled',
      body: signedTxHex, // The resulting signed transaction in raw hex, ready to be broadcasted
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
      error: error,
    };
  }
}

// GET OUTPUT VALUE TOTAL
function getOutputValueTotal(txHex) {
  try {
    const tx = bitcoin.Transaction.fromHex(txHex);
    const outputValueTotal = tx.outs.reduce( (acc, cur) => acc + cur.value, 0 );

    return {
      status: 'fulfilled',
      body: outputValueTotal,
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
    };
  }
}

// BROADCAST TRANSACTION
async function broadcastTransaction({ clientParameters, signedTxHex }) {
  let serverIndex = 0;
  const servers = clientParameters.utxoIndexServer.sendTransaction;

  let request = {};
  request.method = 'POST';
  request.headers = {
    'Accept': 'application/json',
  };
  request.body = signedTxHex;

  SERVER: while (true) {
    const server = servers[serverIndex];

    if (server.status !== 'enabled') {
      serverIndex++;
      continue SERVER;
    }

    let response;
    if (server.type === 'blockbook') {
      request.url = `https://${server.domainAndPath}`;
      // request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.sendTransactionPath}`;
      devLog('broadcast transaction; request', JSON.stringify(request));
      response = await syncHttpRequest(request);
    }
    else if (server.type === 'electrs') {
      request.url = `https://${server.domainAndPath}`;
      devLog('broadcast transaction; request', JSON.stringify(request));
      response = await syncHttpRequestText(request);
    }

    devLog('broadcast transaction; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      let txid;
      if (server.type === 'blockbook') {
        if (response.body.result === undefined) {
          devLog('broadcast transaction; rejected');

          if (serverIndex >= servers.length - 1) {
            return {
              status: 'rejected',
              error: response.error,
            };
          }
          else {
            serverIndex++;
            continue SERVER;
          }
        }

        txid = response.body.result;
      }
      else if (server.type === 'electrs') {
        txid = response.body;
      }

      devLog('txid', txid);

      return {
        status: 'fulfilled',
        body: txid,
      };
    }
    else {
      devLog('broadcast transaction; rejected');

      if (serverIndex >= servers.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// GET BALANCES MONAPARTY
async function getBalancesMonaparty({ dispatch, address, clientParameters }) {
  let balancesArray =[];
  const balances = {};
  // const defaultLimit = clientParameters.counterparty.getTableDefaultLimit;
  const defaultLimit = 500;
  let offset = 0;
  let serverIndex = 0;

  const request = {};
  request.method = 'POST';

  SERVER: while (true) {
    balancesArray =[];
    offset = 0;

    request.url = `https://${clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    // request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';

    while (true) {
      let balancesArrayPartial;
      const bodyObj = {
        jsonrpc: "2.0",
        id: 0,
        method: "proxy_to_counterpartyd",
        params: {
          method: "get_balances",
          params: {
            filters: [
              {field: "address", op: "==", value: address}
            ],
            offset: offset,
            limit: defaultLimit,
          },
        }
      };

      request.body = JSON.stringify(bodyObj);
      devLog('get balances; request', JSON.stringify(request));

      const response = await syncHttpRequest(request);
      devLog('get balances; response', JSON.stringify(response));

      if (response.status === 'rejected') {
        if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
          return {
            status: 'rejected',
            error: {}
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }
      else if (response.body.error !== undefined) {
        if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
          // -- 失敗 エラー返却
          return {
            status: 'rejected',
            error: response.body.error
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }
      else if (response.body.result.length === 0) {
        // -- バランス無し
        balancesArrayPartial = response.body.result;
      }
      else {
        // -- 成功
        balancesArrayPartial = response.body.result;
      }

      balancesArray = balancesArray.concat(balancesArrayPartial);

      if (balancesArrayPartial.length < defaultLimit) {
        break SERVER;
      }
      else {
        offset += defaultLimit;
      }
    }
  }

  // state格納
  for (const balance of balancesArray) {
    balances[balance.asset] = balance;
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'monaparty', address], value: balances });

  if (balancesArray.length === 0) {
    return {
      status: 'notFound',
      body: {},
      bodyArray: [],
    };
  }
  else {
    return {
      status: 'fulfilled',
      body: balances,
      bodyArray: balancesArray,
    };
  }
}

// GET BALANCES MONAPARTY KOM
// 差異は state keys のみと思われるので、 getBalancesMonaparty と統合すべし。
async function getBalancesMonapartyKOM({ dispatch, address, clientParameters }) {
  let balancesArray =[];
  const balances = {};
  // const defaultLimit = clientParameters.counterparty.getTableDefaultLimit;
  const defaultLimit = 500;
  let offset = 0;
  let serverIndex = 0;

  const request = {};
  request.method = 'POST';

  SERVER: while (true) {
    balancesArray =[];
    offset = 0;

    request.url = `https://${clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    // request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';

    while (true) {
      let balancesArrayPartial;
      const bodyObj = {
        jsonrpc: "2.0",
        id: 0,
        method: "proxy_to_counterpartyd",
        params: {
          method: "get_balances",
          params: {
            filters: [
              {field: "address", op: "==", value: address}
            ],
            offset: offset,
            limit: defaultLimit,
          },
        }
      };

      request.body = JSON.stringify(bodyObj);
      devLog('get balances; request', JSON.stringify(request));

      const response = await syncHttpRequest(request);
      devLog('get balances; response', JSON.stringify(response));

      if (response.status === 'rejected') {
        if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
          return {
            status: 'rejected',
            error: {}
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }
      else if (response.body.error !== undefined) {
        if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
          // -- 失敗 エラー返却
          return {
            status: 'rejected',
            error: response.body.error
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }
      else if (response.body.result.length === 0) {
        // -- バランス無し
        balancesArrayPartial = response.body.result;
      }
      else {
        // -- 成功
        balancesArrayPartial = response.body.result;
      }

      balancesArray = balancesArray.concat(balancesArrayPartial);

      if (balancesArrayPartial.length < defaultLimit) {
        break SERVER;
      }
      else {
        offset += defaultLimit;
      }
    }
  }

  // state格納
  for (const balance of balancesArray) {
    balances[balance.asset] = balance;
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['balance', address], value: balances });
  // dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'monaparty', address], value: balances });

  if (balancesArray.length === 0) {
    return {
      status: 'notFound',
      body: {},
      bodyArray: [],
    };
  }
  else {
    return {
      status: 'fulfilled',
      body: balances,
      bodyArray: balancesArray,
    };
  }
}


// GET OWNED ASSETS
async function getOwnedAssets({ dispatch, address, clientParameters}) {
  let ownedAssetsArray =[];
  const ownedAssets = {};
  let serverIndex = 0;

  const request = {};
  request.method = 'POST';

  const bodyObj = {
    jsonrpc: "2.0",
    id: 0,
    method: "get_owned_assets",
    params: {
      addresses: [
        address,
      ],
    },
  };

  request.body = JSON.stringify(bodyObj);

  SERVER: while (true) {
    request.url = `https://${clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    // request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';

    devLog('get owned assets; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get owned assets; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        return {
          status: 'rejected',
          error: {}
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.error !== undefined) {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        // -- 失敗 エラー返却
        return {
          status: 'rejected',
          error: response.body.error
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.result.length === 0) {
      // -- オウンドアッセトは存在しない
      ownedAssetsArray = response.body.result;
      break SERVER;
    }
    else {
      // -- 成功
      ownedAssetsArray = response.body.result;
      break SERVER;
    }
  }

  // state格納

  ownedAssets[address] = [];

  for (const asset of ownedAssetsArray) {
    ownedAssets[address].push(asset);
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['ownedAssets', address], value: ownedAssets[address] });

  // if (ownedAssetsArray.length === 0) {
  //   return {
  //     status: 'notFound',
  //     bodyArray: [],
  //   };
  // }
  // else {
    return {
      status: 'fulfilled',
      bodyArray: ownedAssetsArray,
    };
  // }
}


// GET ASSET INFO
async function getAssetInfo({ dispatch, assets, assetInfos, clientParameters }) {
  let assetInfosArray;
  let serverIndex = 0;

  const request = {};
  request.method = 'POST';

  const bodyObj = {
    jsonrpc: "2.0",
    id: 0,
    method: "get_assets_info",
    params: {
      assetsList: assets,
    }
  };

  request.body = JSON.stringify(bodyObj);

  SERVER: while (true) {
    request.url = `https://${clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    // request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';
    // request.body = `{"jsonrpc":"2.0","id":0,"method":"get_assets_info","params":{"assetsList":["${tokenName}"]}}`;

    devLog('get asset info; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get asset info; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        return {
          status: 'rejected',
          error: {}
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.error !== undefined) {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        // -- 失敗 エラー返却
        return {
          status: 'rejected',
          error: response.body.error
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.result.length === 0) {
      // -- そんなトークンは存在しない
      assetInfosArray = response.body.result;
    }
    else {
      // -- 成功
      assetInfosArray = response.body.result;
      break SERVER;
    }
  }

  // state格納
  for (const assetInfo of assetInfosArray) {
    assetInfos[assetInfo.asset] = assetInfo;
  }

  dispatch({ type: 'setState', key: 'assetInfo', value: assetInfos });

  if (assetInfosArray.length === 0) {
    return { status: 'notFound', body: {} };
  }
  else {
    return { status: 'fulfilled', body: assetInfos };
  }
}

// GET ASSET NAMES
async function getAssetNames({ dispatch, clientParameters }) {
  let assetNames = [];
  let serverIndex = 0;

  const request = {};
  request.method = 'POST';

  const bodyObj = {
    jsonrpc: "2.0",
    id: 0,
    method:"proxy_to_counterpartyd",
    params: {
      method: "get_asset_names",
    }
  };

  request.body = JSON.stringify(bodyObj);

  SERVER: while (true) {
    request.url = `https://${clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    devLog('get asset names; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get asset names; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        return {
          status: 'rejected',
          error: {}
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.error !== undefined) {
      if (serverIndex >= clientParameters.monapaServer.domainAndPath.length - 1) {
        // -- 失敗 エラー返却
        return {
          status: 'rejected',
          error: response.body.error
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
    else if (response.body.result.length === 0) {
      // -- そんなトークンは存在しない
      assetNames = response.body.result;
    }
    else {
      // -- 成功
      assetNames = response.body.result;
      break SERVER;
    }
  }

  // state格納
  dispatch({ type: 'setState', key: 'assetNames', value: assetNames });

  if (assetNames.length === 0) {
    return { status: 'notFound', body: [] };
  }
  else {
    return { status: 'fulfilled', body: assetNames };
  }
}

// GET MONACARD
async function getMonacard({ dispatch, assets, monacards }) {
//  const tokenNamesCSV = tokenNames.reduce( (acc, cur) => `${acc},${cur}`, '' );

  const assetCsvsDivided = [];
  let csv = '';

  for (const asset of assets) {
    if ( (new Blob([csv])).size > 1700 ) {
      assetCsvsDivided.push(csv);
      csv = '';
    }

    csv += ',' + asset;
  }

  assetCsvsDivided.push(csv);

  let request = {};
  let response;
  let monacardsArray = [];

  request.method = 'GET';
  request.body = undefined;

  for (const assetCSV of assetCsvsDivided) {
    request.url = `https://card.mona.jp/api/card_detail?assets=${assetCSV}`
    devLog('get monacard; request', JSON.stringify(request));

    response = await syncHttpRequest(request);
    devLog('get monacard; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      return { status: 'rejected' };
    }
    else if (response.body.error !== undefined) {
      if (response.body.error.message === 'No matched assets.') {
//        return { status: 'notFound', body: [] };
      }
      else {
        return { status: 'rejected', error: response.body.error.message };
      }
    }
    else if (response.body.details === undefined) {
      return { status: 'rejected', error: 'details undefined' };
    }
    else {
      // -- get成功！
//      return { status: 'fulfilled', body: response.body.details };
      monacardsArray = monacardsArray.concat(response.body.details);
    }
  }

  // state格納
  for (const monacard of monacardsArray) {
    monacards[monacard.asset] = monacard;
  }

  dispatch({ type: 'setState', key: 'monacard', value: monacards });

  if (monacardsArray.length === 0) {
    return { status: 'notFound', body: [] };
  }
  else {
    return { status: 'fulfilled', body: monacards };
  }
}

// モナカード情報結局
// GET MONACARD INFO AFTER ALL
function getMonacardInfoAfterAll(state, item, size) {
  let cardName;
  let cardOwnerName;
  let cardDescription;
  let cardTag;
  let cid;
  let cardImageUrl;
  let cardImageUrlSP;
  let isAMonacard;

  if (Object.keys(state.assetInfo).length >= 1) { // 分割取得した場合、完全には働かない。
    if (state.assetInfo[item.asset]?.description !== undefined && state.assetInfo[item.asset]?.description !== null && state.assetInfo[item.asset]?.description !== '') {
      try {
        const description = JSON.parse(state.assetInfo[item.asset].description);
        cardName = description?.monacard.name;
        cardOwnerName = description?.monacard.owner;
        cardDescription = description?.monacard.desc;
        cardTag = description.monacard?.tag;
        cid = description.monacard?.cid;

        if (
          cardName !== undefined && cardName !== null && cardName !== '' &&
          cardOwnerName !== undefined && cardOwnerName !== null && cardOwnerName !== '' &&
          cardDescription !== undefined && cardDescription !== null && cardDescription !== '' &&
          cid !== undefined && cid !== null && cid !== ''
        ) {
          if (size === 'large') {
            cardImageUrl = `${state.config.clientParameters.monacardUrl}${cid}`;
            cardImageUrlSP = `${state.config.clientParameters.monacardUrl}${cid}`;
          }
          else { // small
            cardImageUrl = `${state.config.clientParameters.monacardUrl}${cid}m`;
            cardImageUrlSP = `${state.config.clientParameters.monacardUrl}${cid}t`;
          }

          isAMonacard = true;
        }
        else {
          isAMonacard = false;
        }
      }
      catch (err) {
        if (state.monacard[item.asset] !== undefined) {
          cardName = state.monacard[item.asset].card_name;
          cardOwnerName = state.monacard[item.asset].owner_name;
          cardDescription = state.monacard[item.asset].add_description;
          cardTag = state.monacard[item.asset].tag;
          cardImageUrl = state.monacard[item.asset].imgur_url;
          cardImageUrlSP = state.monacard[item.asset].imgur_url;
          isAMonacard = true;
        }
        else {
          cardName = state.assetInfo[item.asset].asset_longname || item.asset;
          cardOwnerName = null;
          cardDescription = state.assetInfo[item.asset].description;
          cardTag = null;
          cardImageUrl = null;
          cardImageUrlSP = null;

          if (Object.keys(state.monacard).length >= 1) { // 分割取得した場合、完全には働かない。
            isAMonacard = false;
          }
        }
      }
    }
    else if (state.assetInfo[item.asset] !== undefined) {
      if (state.monacard[item.asset] !== undefined) {
        cardName = state.monacard[item.asset].card_name;
        cardOwnerName = state.monacard[item.asset].owner_name;
        cardDescription = state.monacard[item.asset].add_description;
        cardTag = state.monacard[item.asset].tag;
        cardImageUrl = state.monacard[item.asset].imgur_url;
        cardImageUrlSP = state.monacard[item.asset].imgur_url;
        isAMonacard = true;
      }
      else {
        cardName = state.assetInfo[item.asset].asset_longname || item.asset;
        cardOwnerName = null;
        cardDescription = state.assetInfo[item.asset].description;
        cardTag = null;
        cardImageUrl = null;
        cardImageUrlSP = null;

        if (Object.keys(state.monacard).length >= 1) { // 分割取得した場合、完全には働かない。
          isAMonacard = false;
        }
      }
    }
    else { // このケースはありえない想定。
      cardName = null;
      cardOwnerName = null;
      cardDescription = null;
      cardTag = null;
      cardImageUrl = null;
      cardImageUrlSP = null;
      isAMonacard = false;
    }
  }
  else { // アセット情報取得途中
    cardName = null;
    cardOwnerName = null;
    cardDescription = null;
    cardTag = null;
    cardImageUrl = null;
    cardImageUrlSP = null;
  }

  return {
    cardName,
    cardOwnerName,
    cardDescription,
    cardTag,
    cid,
    cardImageUrl,
    cardImageUrlSP,
    isAMonacard,
  };
}

// GET REGISTERED CARD
async function getRegisteredCard(state, dispatch) {
  let request = {};
  let messages = {};
  const registeredCardsIndex = {};

  // state固定
  // const stateFixed = {
  // };

  request.body = JSON.stringify({
    "body": {
    }
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_registered_card';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);

  if ( response.status === 'rejected' ) {
    return {
      status: 'rejected',
    };
  }

  for (const registeredCard of response.body) {
    registeredCardsIndex[registeredCard.asset] = registeredCard;
  }

  dispatch({ type: 'setState', key: 'registeredCard', value: registeredCardsIndex });
  devLog('registeredCard', JSON.stringify(registeredCardsIndex));

  return {
    status: 'fulfilled',
    body: registeredCardsIndex,
  };
}

export {
   buildMonapartyTransactions,
   getTransaction,
   broadcastTransaction,
   broadcastMonaTransactions,
   getUtxo,
   selectUtxoMona,
   selectUtxoWatanabe,
   getRawTransaction,
   getAddressInfo,
   getBalancesMonaparty,
   getBalancesMonapartyKOM,
   getOwnedAssets,
   getAssetNames,
   getAssetInfo,
   getMonacard,
   getMonacardInfoAfterAll,
   getRegisteredCard,
   getFeeRate,
   calculateChangeWatanabe,
   buildUnsignedTransactionSendMona,
   signTransaction,
   getOutputValueTotal,
};
